<template lang="pug">
div.flow-left
	h1 {{contentpage.name}}
	ws-content(:value="contentpage.content")
		v-data-iterator(:items="videos.weblogs" hide-default-footer)
			template(v-slot:item="{ item }")
				weblog-item(:weblog="item")
		template(v-if="pageCount > 1")
			v-pagination.my-6( v-model="page" :length="pageCount" :total-visible="10")
</template>

<script>
import gql from 'graphql-tag';
import MetaFragment from '@/components/graphql/metaFragment.graphql';
import WeblogItem from '@/components/weblog-item';

const contentQuery = gql`
	query getVideosContentIndex($slug: String!, $page: Int) {
		contentpage(slug: $slug) {
			name
			content {
				markdown
			}
			...MetaFragment
		}
		videos: videoWeblogs(page: $page) {
			total
			weblogs {
				...WeblogItem
			}
		}
	}
	${MetaFragment}
	${WeblogItem.fragment}
`;

export default {
	name: 'VideosIndex',
	nuxtI18n: {
		paths: {
			'nl-NL': '/videos',
			'nl-BE': '/videos'
		}
	},
	components: {
		WeblogItem
	},
	scrollToTop: true,
	asyncData({ _params, app, query }) {
		const page = parseInt(query.page) || 1;
		return app.$graphClient
			.query({
				query: contentQuery,
				variables: {
					slug: 'videos',
					page
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (errors) {
					throw errors[0];
				}

				if (!data.contentpage) {
					return Error({ statusCode: 404, message: 'Page not found' });
				}
				data.pageCount = Math.ceil(data.videos.total / 15) || 1;

				data.contentpage.meta.pagination = {
					total: data.pageCount,
					page
				};

				app.meta(data.contentpage.meta);
				app.ads({ sidebar: { visible: true } });
				app.breadcrumbs({
					[app.i18n.t('page.videos:breadcrumb')]: { name: 'videos' }
				});

				return { ...data, page };
			})
			.catch(error => {
				return app.httpError(500, null, 'videos-index-01', error);
			});
	},
	data() {
		return {};
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	watch: {
		page: {
			handler(value) {
				const query = value === 1 ? {} : { page: value };
				this.$router.push({ query });
			}
		}
	},
	watchQuery: ['page']
};
</script>
